import React, { useCallback } from 'react'
import { BtnV2, l } from '@manychat/manyui'

import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { useUserLanguage } from 'apps/locale/hooks/useUserLanguage'
import { getMigrationData } from 'common/billing'
import { MigrationType } from 'common/billing/entities/billingVersions/selectors'
import { migrateFreeUsersToNewBillingModalActions } from 'common/billing/redux/migrateFreeUsersToNewBillingModal'
import { useDidMountEffect } from 'utils/commonHooks'
import { analyticsService } from 'utils/services/analytics'

export const MigrateFreeUsersToNewBillingNotification = () => {
  const dispatch = useAppDispatch()
  const { language } = useUserLanguage()

  const migrationData = useAppSelector(getMigrationData)
  const { endDate } = migrationData?.type === MigrationType.FREE ? migrationData.data : {}
  const formattedEndDate = endDate
    ? new Intl.DateTimeFormat(language, { month: 'long', day: 'numeric' }).format(endDate)
    : ''
  useDidMountEffect(() => {
    analyticsService.sendEvent('NOTIFICATION_BAR.MIGRATE_FREE_USERS_TO_NEW_BILLING.SHOWN')
  })

  const handleRequestUpgradeClick = useCallback(async () => {
    analyticsService.sendEvent(
      'NOTIFICATION_BAR.MIGRATE_FREE_USERS_TO_NEW_BILLING.UPGRADE_NOW.CLICKED',
    )
    dispatch(migrateFreeUsersToNewBillingModalActions.open())
  }, [dispatch])

  return (
    <>
      <span>
        {l.translate(
          'Your Free plan is changing on {formattedEndDate}. Claim 3 months of the all-new Essential plan, on us.',
          { formattedEndDate },
        )}
      </span>
      <BtnV2 variant="success" onClick={handleRequestUpgradeClick} className="m-l-sm">
        {l.translate('See changes')}
      </BtnV2>
    </>
  )
}
